<template>
  <div class="crud_module--timepicker">
    <div class="item" v-if="action == 'View'">
        {{display_name()}}
    </div>
    <div class="item" v-else-if="action == 'List'">
        {{display_name()}}
    </div>
    <div v-else>
        <vue-timepicker v-model="value" @change="selected" format="HH:mm"></vue-timepicker>
    </div>
    
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'


export default {
  components: {
    VueTimepicker,
  },
  props: ["data","k","field","action"],
  beforeMount() {
    this.col = this.field.key;
    if(this.data != undefined && this.data[this.col] != undefined){
        this.value = this.data[this.col];
    }
  },
  methods: {
    selected(){
      this.$emit("input", this.value);
    },
    display_name(){
      return this.data[this.col];
    }
    // getDate (d){
    //     var y = d.getFullYear();
    //     var m = this.fill0(d.getMonth()+1);
    //     var d = this.fill0(d.getDate());
    //     return y+'-'+m+'-'+d
    // },
    // fill0(num){
    //     return num<10?'0'+num:num;
    // }
  },
  computed:{
  },
  data() {
    return {
      value:"",
      col:""
    }
  }
}
</script>

<style lang="scss">
.crud_module--timepicker{
  
}
</style>